import { useLang } from "../lib/i18n";
import useReveal from "../hooks/useReveal";

export const Privacy = () => {
    const { t } = useLang();
    const { ref, visible } = useReveal();

    return (
        <section
            id="privacy"
            ref={ref}
            className={`relative py-24 md:py-32 bg-cream-200 border-t border-navy/10 reveal ${
                visible ? "visible" : ""
            }`}
            data-testid="privacy-section"
        >
            <div className="max-w-5xl mx-auto px-6 md:px-10">
                <div className="flex items-center gap-3 text-xs tracking-[0.25em] uppercase text-navy/60">
                    <span className="tick" />
                    {t.privacy.kicker}
                </div>
                <h2
                    className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl text-navy leading-[1.1] tracking-tight max-w-3xl"
                    data-testid="privacy-heading"
                >
                    {t.privacy.heading}
                </h2>
                <div
                    className="mt-10 space-y-5 text-navy/75 leading-relaxed max-w-3xl text-[15px]"
                    data-testid="privacy-body"
                >
                    {t.privacy.paragraphs.map((p, i) => (
                        <p key={i}>{p}</p>
                    ))}
                </div>
                <div className="mt-10 pt-6 border-t border-navy/15 text-xs uppercase tracking-[0.2em] text-navy/55">
                    {t.privacy.rights}
                </div>
            </div>
        </section>
    );
};

export default Privacy;
